<template>
  <!-- TODO check src/components/my/order/HistoryEmpty.vue:1 -->
  <EmptyOrders
    :isUpdate="isUpdate"
    :appVersion="appVersion"
    :isSign="isSign"
    :hasBmartIcon="hasBmartIcon"
    :moveToBmart="moveToBmart"
  />
</template>

<script>
import EmptyOrders from '../../layouts/organisms/EmptyOrders'
import { Location, MoveType } from '@/plugins/AppManager'

export default {
  name: 'EmptyOrdersContainer',
  components: { EmptyOrders },
  computed: {
    isUpdate() {
      return this.$store.getters['myOrderHistoryV2/isUpdate']
    },

    appVersion() {
      return this.$store.getters['myOrderHistoryV2/appVersion']
    },

    isSign() {
      return this.$store.getters.isSign
    }
  },
  methods: {
    moveToBmart() {
      this.$appManager.move(
        Location.HISTORY_TO_SHOP,
        this.$store.getters.isAndroid,
        MoveType.REPLACE,
        {
          market_cartToolTip: false,
          market_shopNo: this.$store.getters.baeminShopNo
        }
      )
    }
  },
  async mounted() {
    const result = await this.$store.dispatch('myOrderHistoryV2/checkServiceArea')
    this.hasBmartIcon = result.success
  },
  data() {
    return {
      hasBmartIcon: false
    }
  }
}
</script>

<style scoped></style>
